/** Shared second-opinion admin helpers (no React). */

export const CASE_STATUSES = [
  "draft",
  "paid",
  "awaiting_documents",
  "to_verify",
  "to_assign",
  "assigned",
  "in_review",
  "complements_requested",
  "provisional_opinion",
  "visio_pending",
  "final_signed",
  "completed",
  "closed_incomplete",
  "inadmissible",
];

export function specialtyLabel(row) {
  const list = Array.isArray(row?.specialties) ? row.specialties : [];
  if (!list.length) return "—";
  return list
    .map((s) => (s && typeof s === "object" ? s.label || s.uid : String(s)))
    .filter(Boolean)
    .join(", ");
}

export function langCodes(row) {
  const langs = Array.isArray(row?.medicalWorkLanguages) ? row.medicalWorkLanguages : [];
  return langs.map((c) => String(c).toUpperCase()).filter(Boolean);
}

export function initials(name) {
  const parts = String(name || "")
    .replace(/^Dr\.?\s+/i, "")
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return String(name || "?").slice(0, 2).toUpperCase();
}

/** Format fee with its own currency (never hardcode €). */
export function formatMoney(amount, currency) {
  if (amount == null || !Number.isFinite(Number(amount))) return "—";
  const code = String(currency || "")
    .trim()
    .toUpperCase();
  if (!code || code.length !== 3) {
    return `${Number(amount)} (currency unset)`;
  }
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      maximumFractionDigits: code === "KRW" || code === "JPY" ? 0 : 2,
    }).format(Number(amount));
  } catch {
    return `${Number(amount)} ${code}`;
  }
}
